import React from 'react'
import { DialogOverlay, DialogOverlayActions, Separator, Button, DangerButton } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { getPersonName } from '@fs/zion-sls'

const ConfirmUnlinkName = ({ overlay, person, onRemove }) => {
  const [t] = useTranslation()
  return (
    <DialogOverlay {...overlay} title={t('additional-facts-card.confirm-unlink-name.title', 'Remove Fact from Name')}>
      {t('additional-facts-card.confirm-unlink-name.message', 'Are you sure you would like to remove this fact from:')}
      <Separator size="sm" />
      {getPersonName({ person })}
      <Separator size="sm" />
      <DialogOverlayActions>
        <Button
          emphasis="medium"
          data-testid="cancel-unlink-fact-from-name"
          linkName="Additional Facts Cancel Unlink Name"
          onClick={overlay.close}
        >
          {t('additional-facts-card.confirm-unlink-name.cancel.btn', 'Cancel')}
        </Button>
        <DangerButton
          data-testid="confirm-unlink-fact-from-name"
          linkName="Additional Facts Confirm Unlink Name"
          onClick={() => {
            overlay.close()
            onRemove()
          }}
        >
          {t('additional-facts-card.confirm-unlink-name.remove.btn', 'Remove')}
        </DangerButton>
      </DialogOverlayActions>
    </DialogOverlay>
  )
}

export default ConfirmUnlinkName
